import { IBaseProduction, IBasePerformanceGroup, IBasePerformance, IBasePackage, IBaseFacility, IBasePriceType, IBaseZone, IBasePrice, IBasePerformancePricing, IBaseZoneSummary, IBasePackageRequest } from '../../classes/package-listing';

/**
 * Write any custom properties in here. In the case of an update, be sure to revert any unwated changes.
 */
export interface IProduction extends IBaseProduction {

}

export interface IPerformanceGroup extends IBasePerformanceGroup {

}

export interface IPerformance extends IBasePerformance {
    IsDroppable: boolean;
    imageUrl: string;
    specialFeature: string;
}

export interface IPackage extends IBasePackage {
    droppableProductions: Array<number>;
    priceTypeOverrideDictionary: Record<PriceTypeOverrideType, Array<IPriceType>>;
}

export enum PriceTypeOverrideType {
    ACQUISTION = 'acquisition',
    RENEWAL = 'renewal'
}

export interface IPackageRequest extends IBasePackageRequest {
    secondChoiceZoneId: number,
    secondChoicePackageId: number,
}

export interface IFacility extends IBaseFacility {

}

export interface IPriceType extends IBasePriceType {

}

export interface IPerformancePricing extends IBasePerformancePricing {

}

export interface IPackagePricing extends IBasePerformancePricing {

}

export interface IZone extends IBaseZone {

}

export interface IZoneSummary extends IBaseZoneSummary {

}

export interface IPrice extends IBasePrice {

}